<template>
  <div id="app">
    <TitleBar :type="titleBarType" :listeners="listeners" :showRight="showRightButton"></TitleBar>
    <div class="router-view" id="router-view">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import TitleBar from '@/components/widgets/TitleBar'

const DEV = require('@/env.js')

if (DEV.ISDEV) {
  var VConsole = require('vconsole')
  var vc = new VConsole()
  Vue.use(vc)
}

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      transitionName: '',
      showRightButton: true,
      titleBarType: 0,
      isRouterAlive: true,
      listeners: {
        onClickRight () {
        }
      }
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  components: {
    TitleBar
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

#app {
  display: flex;
  flex-direction: column;
}

body {
  margin: 0;
  padding: 0;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms ease-out;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.router-view {
  flex: 1;
  box-sizing: border-box;
  overflow-y: scroll;
  background: #F7F7F9;
}

</style>



// WEBPACK FOOTER //
// src/App.vue